<template>
    <div class="kh-topbar sticky-top">
        <div class="kh-topbar__inner">
            <div class="kh-topbar__left">
                <button class="kh-icon-btn" @click="openNav()" aria-label="Open menu">
                    <ThreeLineMenuIcon />
                </button>
                <a class="kh-logo-link" href="javascript:void(0)"
                    @click="$router.push({ path: '/kids-device', query: { profileId: profileId } })">
                    <img :src="logo" height="20px" alt="Logo" />
                    <!--<span class="kh-logo-name">Wingio</span>-->
                </a>
            </div>

            <!-- Kid pill — centre, only when profile loaded -->
            <div class="kh-kid-pill" v-if="currentProfileName"
                @click="$router.push({ path: '/kids-device', query: { profileId: profileId } })">
                <div class="kh-kid-pill__avatar">
                    <img v-if="currentProfilePic" :src="currentProfilePic" />
                    <span v-else>{{ currentProfileName.charAt(0).toUpperCase() }}</span>
                </div>
                <span class="kh-kid-pill__name">{{ currentProfileName }}</span>
            </div>

            <div class="kh-topbar__right">
                <button class="kh-icon-btn kh-notif-btn" @click="getNotifications()" aria-label="Notifications">
                    <NotificationBellIcon />
                    <span class="kh-notif-dot" v-if="unReadNotificationTotal > 0"></span>
                </button>
                <button class="kh-icon-btn"
                    @click="$router.push({ path: '/parent-profile', query: { profileId: profileId, serialNumber: serialNumber } })"
                    aria-label="Profile">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="3" width="18" height="18" rx="9" stroke="currentColor" stroke-width="1.6"/>
                        <path d="M12 7C10.34 7 9 8.34 9 10C9 11.66 10.34 13 12 13C13.66 13 15 11.66 15 10C15 8.34 13.66 7 12 7Z" stroke="currentColor" stroke-width="1.4"/>
                        <path d="M6.5 19.5C7.5 17 9.5 16 12 16C14.5 16 16.5 17 17.5 19.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- ── Sidebar overlay ── -->
        <div class="kh-overlay" :class="{ 'kh-overlay--visible': sidebarOpen }" @click="closeNav()"></div>

        <!-- ── Sidebar ── -->
        <div class="kh-sidebar" :class="{ 'kh-sidebar--open': sidebarOpen }">
            <!-- Sidebar header -->
            <div class="kh-sidebar__header">
                <div class="kh-sidebar__logo">
                    <img :src="logo" height="22px" alt="Logo" />
                    <span class="kh-sidebar__name">Wingio</span>
                </div>
                <div class="kh-sidebar__header-actions">
                    <button class="kh-logout-btn" @click="logout()">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                        </svg>
                        <span>Logout</span>
                    </button>
                    <button class="kh-icon-btn" @click="closeNav()" aria-label="Close menu">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Nav items -->
            <div class="kh-sidebar__nav">
                <div class="kh-nav-section">Monitoring</div>
                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'Kids Devices' }"
                    @click="navigateTo({ path: '/kids-device', query: { profileId: profileId } })">
                    <span class="kh-nav-item__icon"><DashboardIcon :iconClass="{ 'svg-icon-active': routerName === 'Kids Devices' }" /></span>
                    <span class="kh-nav-item__label">Dashboard</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'Applications List' || routerName === 'Application' }"
                    @click="navigateTo({ path: '/play-store', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><ApplicationsIcon :iconClass="{ 'svg-icon-active': routerName === 'Applications List' }" /></span>
                    <span class="kh-nav-item__label">Apps</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'requests' }"
                    @click="navigateTo({ path: '/requests', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><AppRequestListIcon :iconClass="{ 'svg-icon-active': routerName === 'requests' }" /></span>
                    <span class="kh-nav-item__label">Requests</span>
                    <span class="kh-nav-item__badge" v-if="requestCount > 0">{{ requestCount }}</span>
                </button>
                <div class="kh-nav-section">Controls</div>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'geofence' }"
                    @click="navigateTo({ path: '/geofence', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><GeofenceIcon :iconClass="{ 'svg-icon-active': routerName === 'geofence' }" /></span>
                    <span class="kh-nav-item__label">Location Alerts</span>
                </button>

                <button class="kh-nav-item" v-if="enableSchedule" :class="{ 'kh-nav-item--active': routerName === 'schedule' }"
                    @click="navigateTo({ path: '/schedule', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><ScheduleIcon :iconClass="{ 'svg-icon-active': routerName === 'schedule' }" /></span>
                    <span class="kh-nav-item__label">Schedule</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'global-settings' }"
                    @click="navigateTo({ path: '/global-settings', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><SettingIcon :iconClass="{ 'svg-icon-active': routerName === 'global-settings' }" /></span>
                    <span class="kh-nav-item__label">Settings</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'contacts' }"
                    @click="navigateTo({ path: '/contacts', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><AddressBookIcon :iconClass="{ 'svg-icon-active': routerName === 'contacts' }" /></span>
                    <span class="kh-nav-item__label">Manage Contacts</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'manage-chrome' }"
                    @click="navigateTo({ path: '/manage-chrome', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><ChromeIcon :iconClass="{ 'svg-icon-active': routerName === 'manage-chrome' }" /></span>
                    <span class="kh-nav-item__label">Manage Chrome</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'browser-logs' }"
                    @click="navigateTo({ path: '/browser-logs', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><BrowserLogIcons :iconClass="{ 'svg-icon-active': routerName === 'browser-logs' }" /></span>
                    <span class="kh-nav-item__label">Online Safety</span>
                </button>

                <div class="kh-nav-section">Activity</div>
                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'timeline' }"
                    @click="navigateTo({ path: '/timeline', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><ChartIcon :iconClass="{ 'svg-icon-active': routerName === 'timeline' }" /></span>
                    <span class="kh-nav-item__label">Timeline</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'reports' }"
                    @click="navigateTo({ path: '/reports', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><ReportIcon :iconClass="{ 'svg-icon-active': routerName === 'reports' }" /></span>
                    <span class="kh-nav-item__label">Reports</span>
                </button>
                
                <div class="kh-nav-section">Device</div>
                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'device-info' }"
                    @click="navigateTo({ path: '/device-info', query: { profile_id: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><DeviceIcon :iconClass="{ 'svg-icon-active': routerName === 'device-info' }" /></span>
                    <span class="kh-nav-item__label">Device</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'refer-and-earn' }"
                    @click="navigateTo({ path: '/refer-and-earn', query: { profile_id: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><ReferAndEarnIcon :iconClass="{ 'svg-icon-active': routerName === 'refer-and-earn' }" /></span>
                    <span class="kh-nav-item__label">Refer & Earn</span>
                </button>

                <div class="kh-nav-section">Account</div>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'payment-history' }"
                    @click="navigateTo({ path: '/payment-history', query: { profileId: profileId } })">
                    <span class="kh-nav-item__icon"><PaymentHistoryIcon :iconClass="{ 'svg-icon-active': routerName === 'payment-history' }" /></span>
                    <span class="kh-nav-item__label">Payment History</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'payment-methods' }"
                    @click="navigateTo({ path: '/payment-methods', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><PaymentMethodIcon :iconClass="{ 'svg-icon-active': routerName === 'payment-methods' }" /></span>
                    <span class="kh-nav-item__label">Payment Methods</span>
                </button>

                <button class="kh-nav-item" :class="{ 'kh-nav-item--active': routerName === 'change-password' }"
                    @click="navigateTo({ path: '/change-password', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <span class="kh-nav-item__icon"><ChangePasswordIcon :iconClass="{ 'svg-icon-active': routerName === 'change-password' }" /></span>
                    <span class="kh-nav-item__label">Change Password</span>
                </button>
            </div>

            <!-- Help — outside nav scroll, always visible -->
            <div class="kh-sidebar__help">
                <button class="kh-help-btn"
                    @click="navigateTo({ path: '/contact-us', query: { profileId: profileId, serialNumber: serialNumber } })">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                        <path d="M12 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <span>Need help? Contact us</span>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" style="margin-left:auto; flex-shrink:0;">
                        <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- ── Notification Panel ── -->
        <div class="kh-panel-overlay" :class="{ 'kh-panel-overlay--visible': notifOpen }" @click="closeNotificationPopup()"></div>
        <div class="kh-notif-panel" :class="{ 'kh-notif-panel--open': notifOpen }">
            <div class="kh-notif-panel__header">
                <span class="kh-notif-panel__title">Notifications</span>
                <button class="kh-icon-btn" @click="closeNotificationPopup()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>

            <!-- Scrollable body -->
            <div class="kh-notif-panel__body">
                <div class="kh-notif-loader" v-if="showLoader">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Loading...</span>
                </div>

                <div class="kh-notif-list" v-else-if="notificationList.length > 0">
                    <div class="kh-notif-item" v-for="notification in notificationList" :key="notification._id"
                        @click="handleNotificationClick(notification)">
                        <div class="kh-notif-item__avatar">
                            <img v-if="notification.icon" :src="notification.icon" />
                            <img v-else src="https://static.vecteezy.com/system/resources/thumbnails/022/059/000/small/no-image-available-icon-vector.jpg" />
                        </div>
                        <div class="kh-notif-item__body">
                            <!--<span class="kh-notif-item__msg">{{ notification.message }}</span>-->
                            <span class="kh-notif-item__msg">
                            <template v-if="notification.created_by !== loginUser">
                                <strong>{{ notification.created_by }}</strong><br>
                            </template>
                            {{ notification.message }}
                            </span>
                            <div class="kh-notif-item__meta">
                                <span class="kh-notif-item__type" :class="notification.typeClass" v-if="notification.type">{{ notification.type }}</span>
                                <span class="kh-notif-item__time">{{ formatDate(notification.created_at) }}</span>
                            </div>
                        </div>
                        <div class="kh-notif-item__chevron">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="kh-notif-empty" v-else>
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    <span>No notifications yet</span>
                </div>
            </div>

            <!-- Load more — outside scroll, always visible -->
            <div class="kh-notif-panel__footer" v-if="!showLoader && totalNotificationsCount > (currentPage * limit)">
                <button class="kh-notif-more" @click="showMoreNotifications()">
                    Load more
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- ── Logout confirm modal ── -->
        <div class="kh-modal-overlay" v-if="showLogoutModal" @click.self="showLogoutModal = false">
            <div class="kh-modal">
                <div class="kh-modal__title">Log out?</div>
                <div class="kh-modal__body">You'll need to sign in again to access your account.</div>
                <div class="kh-modal__footer">
                    <button class="kh-modal__cancel" @click="showLogoutModal = false">Cancel</button>
                    <button class="kh-modal__confirm" @click="doLogout()">Log out</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KidsService from "../services/KidsService";
import UserService from "../services/UserService";
import DashboardIcon from '@/components/icons/DashboardIcon.vue'
import ApplicationsIcon from '@/components/icons/ApplicationsIcon.vue'
import AppRequestListIcon from '@/components/icons/AppRequestListIcon.vue'
import BrowserLogIcons from '@/components/icons/BrowserLogIcons.vue'
import PaymentHistoryIcon from '@/components/icons/PaymentHistoryIcon.vue'
import PaymentMethodIcon from '@/components/icons/PaymentMethodIcon.vue'
import ChangePasswordIcon from '@/components/icons/ChangePasswordIcon.vue'
import ThreeLineMenuIcon from '@/components/icons/ThreeLineMenuIcon.vue'
import NotificationBellIcon from '@/components/icons/NotificationBellIcon.vue'
import NeedHelpIcon from '@/components/icons/NeedHelpIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import ScheduleIcon from '@/components/icons/ScheduleIcon.vue'
import SettingIcon from '@/components/icons/SettingIcon.vue'
import DeviceIcon from '@/components/icons/DeviceIcon.vue'
import ReferAndEarnIcon from '@/components/icons/ReferAndEarn.vue'
import AddressBookIcon from '@/components/icons/AddressBookIcon.vue'
import ReportIcon from '@/components/icons/ReportIcon.vue'
import GeofenceIcon from '@/components/icons/GeofenceIcon.vue'
import ChromeIcon from '@/components/icons/ChromeIcon.vue'
import ChartIcon from '@/components/icons/ChartIcon.vue'
import { getCurrentProfile, clearCurrentProfile, setCurrentProfile } from '@/utils/currentProfile.js';

export default {
    name: 'KidHeader',
    components: {
        ChromeIcon, ReportIcon, SettingIcon, DeviceIcon, ReferAndEarnIcon,
        AddressBookIcon, PaymentMethodIcon, DashboardIcon, ApplicationsIcon,
        AppRequestListIcon, BrowserLogIcons, PaymentHistoryIcon, ChangePasswordIcon,
        ThreeLineMenuIcon, NotificationBellIcon, NeedHelpIcon, LogoutIcon,
        CrossCloseIcon, ScheduleIcon, GeofenceIcon, ChartIcon
    },
    props: {
        serialNumber: String,
        profileId: String,
        logo: { type: String, default: "/images/lya-logo.png" },
    },
    data() {
        return {
            routerName: this.$route.name,
            notificationList: [],
            unReadNotificationTotal: 0,
            showLoader: false,
            currentPage: 1,
            limit: 20,
            totalNotificationsCount: 0,
            requestCount: 0,
            enableSchedule: false,
            sidebarOpen: false,
            notifOpen: false,
            showLogoutModal: false,
            loginUser: null,
            currentProfileName: '',
            currentProfilePic: null,
        }
    },
    methods: {
        navigateTo(route) {
            this.closeNav();
            this.$router.push(route).catch(() => {});
        },
        openNav() { this.sidebarOpen = true; },
        closeNav() { this.sidebarOpen = false; },
        closeNotificationPopup() { this.notifOpen = false; },
        logout() {
            this.closeNav();
            this.showLogoutModal = true;
        },
        doLogout() {
            UserService.logout({ serialNumber: this.serialNumber, profileId: this.profileId })
            .then((response) => {
                clearCurrentProfile();
                localStorage.removeItem('token');
                //this.$toast.success(response.data.respones_msg);
                if (localStorage.getItem('hideGoogleLogin') === 'true') {
                    document.location = "/login?hideGBtn=true";
                } else {
                    this.$router.push('login');
                }
            }).catch((e) => {
                const error = e.response?.data;
                if (e.response?.status === 401 && error?.is_logout) {
                    localStorage.removeItem('token');
                    this.$toast.error(error.respones_msg);
                    this.$router.push('/login');
                    return;
                }

                this.$toast.error(error?.respones_msg || 'Something went wrong');
            });
        },
        loadCurrentProfileFromStorage() {
            const profile = getCurrentProfile();
            if (profile) {
                this.currentProfileName = profile.profile_name || '';
                this.currentProfilePic = profile.kidProfilePic || null;
            }
        },
        async getNotifications() {
            this.notifOpen = true;
            this.showLoader = true;
            await KidsService.getNotifications({ serialNumber: this.serialNumber, currentPage: this.currentPage })
            .then((response) => {
                this.notificationList = response.data.data;
                this.totalNotificationsCount = response.data.totalNotifications;
                this.unReadNotificationTotal = 0;
                this.loginUser = response.data.loginUser;
            })
            .catch((e) => { this.$toast.error(e.response.data.respones_msg); })
            .finally(() => { this.showLoader = false; });
        },
        handleNotificationClick(notification) {
            const types = ['App Installed', 'App Disabled', 'App Enabled', 'Daily Limit Enabled', 'Daily Limit Disabled'];
            if (types.includes(notification.type)) {
                this.$router.push({ path: '/application', query: { package_name: notification.packageName, profile_id: notification.profileId, serialNumber: notification.serialNumber, type: notification.type } });
            } else if (notification.type === 'App Request') {
                this.$router.push({ path: '/requests', query: { profileId: notification.profileId, serialNumber: notification.serialNumber } });
            } else if (notification.type === 'Rate App') {
                this.$router.push({ path: '/application', query: { package_name: notification.packageName, profile_id: notification.profileId, serialNumber: notification.serialNumber, showRating: true } });
            }
            this.notifOpen = false;
        },
        async unReadNotificationCount() {
            await KidsService.unReadNotificationCount({ serialNumber: this.serialNumber, profileId: this.profileId })
            .then((response) => {
                this.unReadNotificationTotal = response.data.data;
                this.requestCount = response.data.appRequestCount;
                this.enableSchedule = response.data.enableSchedule;
            }).catch((e) => {
                if (e.response?.data?.is_logout) this.$router.push({ path: '/login' });
            });
        },
        async showMoreNotifications() {
            this.currentPage++;
            await this.getNotifications();
        },
        formatDate(date) {
            return new Date(date).toLocaleString(undefined, {
                year: 'numeric', month: 'short', day: 'numeric',
                hour: 'numeric', minute: '2-digit', hour12: true
            });
        }
    },
    watch: {
        serialNumber() { this.unReadNotificationCount(); }
    },
    beforeMount() {
        this.unReadNotificationCount();
        this.loadCurrentProfileFromStorage();
        // ← add this
        window.addEventListener('profile-changed', this.loadCurrentProfileFromStorage);
    },
    beforeDestroy() {
        // ← add this
        window.removeEventListener('profile-changed', this.loadCurrentProfileFromStorage);
    },
}
</script>

<style scoped>
/* ── Topbar ── */
.kh-topbar {
    background: #fff;
    border-bottom: 0.5px solid #e5e7eb;
    z-index: 100;
    width: 100%;
}
.kh-topbar__inner {
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 8px;
    max-width: 575px;
    margin: 0 auto;
}
.kh-topbar__left {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
}
.kh-topbar__right {
    display: flex;
    align-items: center;
    gap: 0;
    flex-shrink: 0;
    margin-left: auto;
}

/* ── Kid pill ── */
.kh-kid-pill {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    padding: 0 10px 0 4px;
    background: #f9fafb;
    border: 0.5px solid #e5e7eb;
    border-radius: 20px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    min-width: 0;
    max-width: 130px;
    margin-left: 8px;
    overflow: hidden;
    transition: background 0.12s;
    flex-shrink: 1;
}
.kh-kid-pill:active { background: #f3f4f6; }

.kh-kid-pill__avatar {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-weight: 700;
}
.kh-kid-pill__avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.kh-kid-pill__name {
    font-size: 11px;
    font-weight: 600;
    color: #374151;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Icon button ── */
.kh-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 10px;
    border: none;
    background: none;
    color: #374151;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: background 0.15s;
}
.kh-icon-btn:active { background: #f3f4f6; }

/* ── Logo ── */
.kh-logo-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
    padding: 6px 4px;
    -webkit-tap-highlight-color: transparent;
}
.kh-logo-name {
    font-size: 17px;
    font-weight: 700;
    color: #111;
    letter-spacing: -0.3px;
}

/* ── Notification dot ── */
.kh-notif-btn { position: relative; }
.kh-notif-dot {
    position: absolute;
    top: 9px; right: 9px;
    width: 8px; height: 8px;
    background: #dc2626;
    border-radius: 50%;
    border: 2px solid #fff;
    pointer-events: none;
}

/* ── Overlays ── */
.kh-overlay, .kh-panel-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0);
    z-index: 199;
    pointer-events: none;
    transition: background 0.25s;
}
.kh-overlay--visible, .kh-panel-overlay--visible {
    background: rgba(0,0,0,0.4);
    pointer-events: all;
}

/* ── Sidebar ── */
.kh-sidebar {
    position: fixed;
    top: 0; left: 0;
    width: 0;
    max-width: 300px;
    height: 100dvh;
    background: #fff;
    z-index: 200;
    overflow: hidden;
    transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    box-shadow: 4px 0 20px rgba(0,0,0,0.08);
}
.kh-sidebar--open { width: 300px; }

/* ── Sidebar header ── */
.kh-sidebar__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 8px 12px 16px;
    border-bottom: 0.5px solid #f3f4f6;
    flex-shrink: 0;
}
.kh-sidebar__logo { display: flex; align-items: center; gap: 8px; }
.kh-sidebar__name { font-size: 17px; font-weight: 700; color: #111; }
.kh-sidebar__header-actions { display: flex; align-items: center; gap: 6px; }

.kh-logout-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 34px;
    padding: 0 10px;
    border-radius: 8px;
    border: 0.5px solid #fecaca;
    background: #fff5f5;
    color: #dc2626;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    -webkit-tap-highlight-color: transparent;
    vertical-align: middle;
}
.kh-logout-btn svg { flex-shrink: 0; display: block; }
.kh-logout-btn span { line-height: 1; display: block; }
.kh-logout-btn:active { background: #fee2e2; }

/* ── Sidebar nav ── */
.kh-sidebar__nav {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 8px 0 0;
    scrollbar-width: none;
}
.kh-sidebar__nav::-webkit-scrollbar { display: none; }

/* ── Nav section label ── */
.kh-nav-section {
    font-size: 10px;
    font-weight: 700;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    padding: 10px 16px 4px;
    margin-top: 4px;
    text-align: left;
}

/* ── Nav items ── */
.kh-nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 11px 16px;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: background 0.12s;
}
.kh-nav-item:active { background: #f3f4f6; }
.kh-nav-item--active { background: #eff6ff; }
.kh-nav-item--active .kh-nav-item__label { color: #2563eb; font-weight: 600; }
.kh-nav-item--active .kh-nav-item__icon { color: #2563eb; }
.kh-nav-item--danger .kh-nav-item__label { color: #dc2626; }
.kh-nav-item--danger .kh-nav-item__icon { color: #dc2626; }

.kh-nav-item__icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #6b7280;
}
.kh-nav-item__label {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
}
.kh-nav-item__badge {
    background: #f59e0b;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 20px;
    flex-shrink: 0;
}
.kh-nav-divider {
    height: 0.5px;
    background: #f3f4f6;
    margin: 8px 16px;
}

/* ── Help — pinned at bottom ── */
.kh-sidebar__help {
    flex-shrink: 0;
    background: #fff;
    border-top: 0.5px solid #f3f4f6;
    padding: 10px 12px;
    padding-bottom: max(14px, env(safe-area-inset-bottom, 14px));
}
.kh-help-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 11px 14px;
    background: #fff5f5;
    border: 0.5px solid #fecaca;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    color: #dc2626;
    cursor: pointer;
    text-align: left;
    -webkit-tap-highlight-color: transparent;
}
.kh-help-btn:active { background: #fee2e2; }

/* ── Notification panel ── */
.kh-notif-panel {
    position: fixed;
    left: 0; right: 0;
    bottom: 0;
    max-width: 575px;
    margin: 0 auto;
    background: #fff;
    border-radius: 20px 20px 0 0;
    z-index: 200;
    transform: translateY(100%);
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 80dvh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.1);
}
.kh-notif-panel--open { transform: translateY(0); }

.kh-notif-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 12px;
    border-bottom: 0.5px solid #f3f4f6;
    flex-shrink: 0;
}
.kh-notif-panel__title { font-size: 16px; font-weight: 700; color: #111; }

.kh-notif-panel__body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}
.kh-notif-panel__body::-webkit-scrollbar { display: none; }

.kh-notif-panel__footer {
    flex-shrink: 0;
    border-top: 0.5px solid #f3f4f6;
    padding-bottom: 0;
}

@media (max-width: 575px) {
    .kh-notif-panel {
        max-height: calc(90dvh - 60px);
        bottom: 60px;
        transform: translateY(calc(100% + 60px));
    }
    .kh-notif-panel--open {
        transform: translateY(0);
    }
}

.kh-notif-more {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 100%;
    padding: 14px 16px;
    background: none;
    border: none;
    font-size: 13px;
    font-weight: 600;
    color: #2563eb;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

/* ── Notification items ── */
.kh-notif-list { padding: 4px 0; }
.kh-notif-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 0.5px solid #f9fafb;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: background 0.12s;
    text-align: left;
}
.kh-notif-item:last-child { border-bottom: none; }
.kh-notif-item:active { background: #f9fafb; }

.kh-notif-item__avatar {
    width: 40px; height: 40px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    border: 0.5px solid #e5e7eb;
}
.kh-notif-item__avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }

.kh-notif-item__body {
    flex: 1; min-width: 0;
    display: flex; flex-direction: column; gap: 4px;
}
.kh-notif-item__msg { font-size: 13px; font-weight: 500; color: #111; line-height: 1.4; }
.kh-notif-item__meta { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.kh-notif-item__type {
    font-size: 10px; font-weight: 600;
    background: #eff6ff; color: #2563eb;
    padding: 2px 7px; border-radius: 20px;
}
.kh-notif-item__time { font-size: 11px; color: #9ca3af; }
.kh-notif-item__chevron { color: #d1d5db; flex-shrink: 0; margin-top: 2px; }

/* ── Empty / Loader ── */
.kh-notif-empty, .kh-notif-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 40px 16px;
    color: #9ca3af;
    font-size: 13px;
}

/* ── Logout modal ── */
.kh-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 300;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.kh-modal {
    background: #fff;
    border-radius: 20px 20px 0 0;
    width: 100%;
    max-width: 575px;
    padding: 20px 16px 32px;
    animation: slideUp 0.25s ease;
}
@media (max-width: 575px) {
    .kh-modal {
        padding-bottom: calc(60px + env(safe-area-inset-bottom, 16px));
    }
}
@keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
}
.kh-modal__title { font-size: 17px; font-weight: 700; color: #111; margin-bottom: 8px; }
.kh-modal__body { font-size: 13px; color: #6b7280; line-height: 1.5; margin-bottom: 20px; }
.kh-modal__footer { display: flex; gap: 10px; }
.kh-modal__cancel {
    flex: 1; height: 44px; border-radius: 12px;
    border: 0.5px solid #e5e7eb; background: #f3f4f6;
    font-size: 14px; font-weight: 600; color: #374151; cursor: pointer;
}
.kh-modal__confirm {
    flex: 1; height: 44px; border-radius: 12px; border: none;
    background: #dc2626; color: #fff;
    font-size: 14px; font-weight: 600; cursor: pointer;
}

button:focus { outline: none; }
</style>